import $ from "jquery";
import { closeSearch } from "./header-search.js";

$(function () {
  if ($(".fp").length) return false;

  // Hide and darken header on scroll down past page header
  var $header = $(".header");
  var $window = $(window);
  var headerHiddenClass = "is-hidden";
  var lastScrollTop = 0;

  $window.scroll(function () {
    if (window.preventHeaderHide === 1) return false;

    var st = window.pageYOffset || document.documentElement.scrollTop;
    var threshold = 200;

    // scroll down
    if (st > lastScrollTop) {
      $header.toggleClass(headerHiddenClass, st > threshold);
      // close search
      closeSearch();
    }
    // ignore IE smooth scroll
    else if (st == lastScrollTop) {
    }
    // scroll up
    else {
      $header.removeClass(headerHiddenClass);
    }

    lastScrollTop = st <= 0 ? 0 : st;
  });
});
